import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { userService } from 'services';

const initialState = {
  data: {},
  detailData: {},
  filter: {
    name: '',
    id: ''
  },
  statusList: 'idle',
  statusDetail: '',
  statusDelete: '',
  statusSubmit: '',
  statusCheckUsername: '',
  dataUsername: '',
  statusLoginHistory: '',
  dataLoginHistory: []
};

export const getList = createAsyncThunk(
  'user/fetchList',
  async (data) => {
    const response = await userService.list(data);
    return response;
  }
);

export const getDetail = createAsyncThunk(
  'user/fetchById',
  async (data) => {
    const response = await userService.show(data);
    return response;
  }
);

export const deleteData = createAsyncThunk(
  'user/fetchDelete',
  async (data) => {
    const response = await userService.remove(data);
    return response;
  }
);

export const createData = createAsyncThunk(
  'user/fetchCreate',
  async (data) => {
    const response = await userService.create(data);
    return response;
  }
);

export const editData = createAsyncThunk(
  'user/fetchUpdate',
  async (data) => {
    const response = await userService.update(data);
    return response;
  }
);

export const checkUsername = createAsyncThunk(
  'user/fetchCheckUsername',
  async (data) => {
    const response = await userService.checkUsername(data);
    return response;
  }
);

export const getLoginHistory = createAsyncThunk(
  'user/fetchLoginHistory',
  async (data) => {
    const response = await userService.getLoginHistoryByUsername(data);
    return response;
  }
);

export const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setFilter: (state, action) => {
      const data = action.payload;
      state.filter = data;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if(typeof payload === 'string'){
        state[payload] = initialState[payload];
      }else if(Array.isArray(payload)){
        payload.forEach(item => 
          state[item] = initialState[item]
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state) => {
        state.statusList = 'loading';
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.statusList = 'success';
        state.data = action.payload;
      })
      .addCase(getList.rejected, (state) => {
        state.statusList = 'error';
      })
      .addCase(getDetail.pending, (state) => {
        state.statusDetail = 'loading';
      })
      .addCase(getDetail.fulfilled, (state, action) => {
        state.statusDetail = 'success';
        state.detailData = action.payload;
      })
      .addCase(getDetail.rejected, (state) => {
        state.statusDetail = 'error';
      })
      .addCase(deleteData.pending, (state) => {
        state.statusDelete = 'loading';
      })
      .addCase(deleteData.fulfilled, (state, action) => {
        state.statusDelete = 'success';
      })
      .addCase(deleteData.rejected, (state) => {
        state.statusDelete = 'error';
      })
      .addCase(createData.pending, (state) => {
        state.statusSubmit = 'loading';
      })
      .addCase(createData.fulfilled, (state) => {
        state.statusSubmit = 'success';
      })
      .addCase(createData.rejected, (state) => {
        state.statusSubmit = 'error';
      })
      .addCase(editData.pending, (state) => {
        state.statusSubmit = 'loading';
      })
      .addCase(editData.fulfilled, (state) => {
        state.statusSubmit = 'success';
      })
      .addCase(editData.rejected, (state) => {
        state.statusSubmit = 'error';
      })
      .addCase(checkUsername.pending, (state) => {
        state.statusCheckUsername = 'loading';
      })
      .addCase(checkUsername.fulfilled, (state, action) => {
        state.statusCheckUsername = 'success';
        state.dataUsername = action.payload;
      })
      .addCase(checkUsername.rejected, (state) => {
        state.statusCheckUsername = 'error';
      })
      .addCase(getLoginHistory.pending, (state) => {
        state.statusLoginHistory = 'loading';
      })
      .addCase(getLoginHistory.fulfilled, (state, action) => {
        state.statusLoginHistory = 'success';
        state.dataLoginHistory = action.payload;
      })
      .addCase(getLoginHistory.rejected, (state) => {
        state.statusLoginHistory = 'error';
      });
  }
});

export const { setFilter, resetData } = userSlice.actions;

const userReducer = userSlice.reducer;
export default userReducer;